import { HttpErrorResponse } from '@angular/common/http';
import { ProfileService } from '../../service/profile.service';
import { SubService } from '../../service/sub.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { RetailStoreData } from 'src/app/class/RetailStoreData';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {
  isLoading = true;
  retailStore: RetailStoreData;

  constructor(
    private route: ActivatedRoute,
    private subService: SubService,
    private router: Router,
    private profile: ProfileService
  ) {}

  ngOnInit() {
    this.route.queryParamMap
      .pipe(
        map((params) => {
          this.profile.setOrderHash(params.get('orderHash'));
        })
      )
      .subscribe();

    const observable = [
      this.subService.getOrder(),
      this.subService.getSubsRemaining(),
      this.subService.getCustSubsRemaining(),
      this.subService.getBackupSubsRemaining(),
      this.subService.getOutOfStockItems(),
      this.subService.getRetailStore()
    ];

    forkJoin(observable).subscribe(
      (results: any) => {
        const remainingOrderSubs = results[1];
        const remainingCustSubs = results[2];
        const remainingBackupSubs = results[3];
        this.retailStore = results[5];
        // determine which stage we should be in
        this.isLoading = false;
        if (remainingOrderSubs.length > 0 || (this.retailStore.isCustomerChoiceEnabled && 
          (remainingCustSubs.length > 0 || remainingBackupSubs.length > 0))) {
          this.router.navigate(['welcome/review'], {
            skipLocationChange: true,
            queryParamsHandling: 'preserve'
          });
        } else {
          this.router.navigate(['welcome/final'], {
            skipLocationChange: true,
            queryParamsHandling: 'preserve'
          });
        }
      },
      (error) => {
        let routeData = {};
        if (error instanceof HttpErrorResponse && error.status === 401) {
          routeData = {
            title: 'Order Window Expired',
            text: 'This order is no longer viewable from this page.'
          };
        }
        this.router.navigate(['error', routeData], {
          skipLocationChange: true
        });
      }
    );
  }
}
